import { render, staticRenderFns } from "./GroupRidesTransactionsViewTable.vue?vue&type=template&id=01c14713&lang=pug&"
import script from "./GroupRidesTransactionsViewTable.vue?vue&type=script&lang=js&"
export * from "./GroupRidesTransactionsViewTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupRidesTransactionsViewTable.vue?vue&type=style&index=0&id=01c14713&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports